<template>
  <!-- 顶部标题栏 - 完全还原截图 -->
    <div class="title-header">
        <!-- 左侧文字 -->
        <div class="left-info">
            <span class="projectName">项目：{{projectName}} - 审图进行中</span>
            <span class="split">|</span>
            <span>图纸版本：{{ currentVersion.version }}</span>
        </div>

        <!-- 右侧按钮：全屏/收起 + 关闭 -->
        <div class="right-actions">
            <a-button @click="toggleFullscreen" type="link" :icon="isFullscreen ? 'fullscreen-exit' : 'fullscreen'">{{ isFullscreen ? '收起' : '全屏' }}</a-button>
        </div>
    </div>
</template>

<script>
export default {
    name: "DrawingTitleBar",
    props:{
        projectName:{
            type: String,
            default: null
        },
        currentVersion: {
            type: Object,
            default: () => ({ version: "", time: "" })
        }
    },
    data() {
        return {
            isFullscreen: false,
        };
    },
    mounted() {
        document.addEventListener("fullscreenchange", this.onFullscreenChange);
    },
    beforeDestroy() {
        document.removeEventListener("fullscreenchange", this.onFullscreenChange);
    },
    methods: {
        onFullscreenChange() {
            this.isFullscreen = !!document.fullscreenElement;
        },
        toggleFullscreen() {
            if (document.fullscreenElement) {
                document.exitFullscreen();
            } else {
                document.documentElement.requestFullscreen();
            }
        },
        handleClose() {
            this.$emit("close");
        },
    },
};
</script>

<style lang="less" scoped>
// 1:1 还原容器
.title-header {
  width: 100%;
  height: 60px;
  background: #ffffff;
  border-bottom: 1px solid #e5e6eb;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 20px;
  box-sizing: border-box;
  font-size: 14px;
  color: #333;
}
.projectName{
  font-size: 16px;
  font-weight: 600;
}
// 左侧信息
.left-info {
  display: flex;
  align-items: center;
  gap: 12px;

  .split {
    color: #dcdfe6;
  }
}

// 右侧按钮组
.right-actions {
  display: flex;
  gap: 12px;

  /deep/ .ant-btn {
    height: 30px;
    padding: 0 12px;
    font-size: 14px;
    border-radius: 2px;
    display: flex;
    align-items: center;
    justify-content: center;
    color: #555;
  }
  /deep/ .ant-btn .anticon {
    color: #555;
  }
}
</style>